import { LOGS, useConsoleCategories } from "@cs_teamwaydev/mailvista-sdk_react";
import { useState } from "react";

export function FloatingLogSettings() {
    const [open, setOpen] = useState(false);
    const { enabledCategories, setCategoryEnabled } = useConsoleCategories();

    // Styles inline plutôt que des classes Tailwind
    const buttonStyle = {
        position: "fixed",
        bottom: "16px",
        right: "16px",
        zIndex: 50,
        backgroundColor: "#0066cc",
        color: "white",
        padding: "8px 16px",
        borderRadius: "9999px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    };

    const panelStyle = {
        position: "absolute",
        bottom: "60px",
        right: "0",
        backgroundColor: "white",
        borderRadius: "8px",
        boxShadow: "0 10px 15px rgba(0, 0, 0, 0.1)",
        padding: open ? "16px" : "0",
        width: open ? "256px" : "0",
        height: open ? "400px" : "0",
        overflow: "hidden",
        transition: "all 0.3s ease",
        overflowY: open ? ("auto" as const) : ("hidden" as const),
    };

    const titleStyle = {
        marginBottom: "8px",
        fontSize: "14px",
        fontWeight: 600,
        color: "black",
    };

    const labelStyle = {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        marginBottom: "8px",
        fontSize: "14px",
        color: "black",
    };

    return (
        <div style={buttonStyle as React.CSSProperties}>
            <button
                style={{ cursor: "pointer" }}
                onClick={() => setOpen(!open)}
                type="button"
            >
                Logs
            </button>

            <div style={panelStyle as React.CSSProperties}>
                <h4 style={titleStyle}>Log Settings</h4>
                {Object.values(LOGS).map((category) => {
                    const enabled = enabledCategories.includes(category);

                    return (
                        <label
                            key={category}
                            style={labelStyle}
                            htmlFor={category}
                        >
                            <input
                                checked={enabled}
                                id={category}
                                onChange={() =>
                                    setCategoryEnabled(category, !enabled)
                                }
                                type="checkbox"
                            />
                            <span>{category}</span>
                        </label>
                    );
                })}
            </div>
        </div>
    );
}
